module.exports = __webpack_public_path__ + "img/tit-school.ec409854.jpg";